import { DateTime } from 'typescript-dotnet-es6/System/Time/DateTime'
import * as moment from 'moment-timezone';

export class RIAHelper{
    /**
     * ConvertRIADate  "\/Date(1503723600000-0500)\/"
     */
    public static ConvertRIADate(dateStr: string):Date {
        if(dateStr == undefined)
            return new Date();
        var str = dateStr.substr(6, 13);

        let datePart =  new Date(Number.parseInt(str));
        //note: the TZ part, -0500, is just informational console.log(datePart);

        return datePart;
    }
    public static CreateRIADateForDateTime(date: DateTime):string {
      if(date){
        return RIAHelper.CreateRIADate(date.toJsDate());
      }
    }
    static lastTwo(str:string){
      if(str.length>=3){
        return str.substr(str.length-2,2);
      }
      return str;
    }
    public static CreateRIADate(date: Date):string {
      if(date == undefined) {
        return '';
      }
      var minutes = date.getTimezoneOffset();//difference in MINUTES convert to HMM
      var sign= minutes>0?'-':'+';
      var hours = this.lastTwo('0' + ( (minutes/60)|0));
      var min = this.lastTwo('00' + minutes%60);
      var timezone = sign+hours+min;
      if(!timezone) {
        //if for some reason timezone is not defined, default to 0500
        timezone = '-0500';
      }
      var str =  "\/Date(" +date.valueOf() + timezone + ")\/";

      //note: the TZ part, -0500, is just informational console.log(datePart);

      return str;
  }
  public static ConvertDateForRateAvail(dateStr: string):String {
    if(dateStr == undefined || dateStr==null || dateStr=="")
        return new Date().toISOString();
    let datePart =  new Date(dateStr);
    //note: the TZ part, -0500, is just informational console.log(datePart);
    return datePart.toISOString();
  }

  public static BuildWsDateFromDateTimeForRateAvail(date:DateTime):string {
    if(date == undefined || date==null )
        date = new DateTime();
    let datePart =  date.date;
    return RIAHelper.BuildWsDateFromDateForRateAvail(datePart.toJsDate());
  }

  public static BuildWsDateFromDateTimeForRateAudit(date:DateTime):string {
    if(date == undefined || date==null )
       return '';
    let datePart =  date.date;
    return RIAHelper.BuildWsDateFromDateForRateAvail(datePart.toJsDate());
  }

  public static BuildWsDateFromDateForRateAvail(date:Date):string {
    if(date == undefined || date==null )
        return null;
    let dateStr =""+date.getFullYear()+"-"+RIAHelper.FormatMonthDay(date.getMonth()+1)+"-"+RIAHelper.FormatMonthDay(date.getDate());
    return dateStr;
  }

  public static FormatMonthDay(nbr:number){
    let str = ("0"+nbr);
    if(str.length>2){
      str = str.slice(1);
    }
    return str;
  }

  public static ConvertToDate(dateStr: string):Date {
    var datePart:Date;

    if(dateStr != undefined && dateStr!=null && dateStr!=""){
      datePart =  new Date(dateStr);
    }
    return datePart;
  }
}
